module.exports = __webpack_public_path__ + "media/05.0ea4e96d.mp3";